import './App.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import Checkout from "./components/layout/Checkout"
import {PaymentStatusContextProvider} from "./contexts/PaymentStatusContext"
import {Secure3DContextProvider} from "./contexts/Secure3DContext"
import {MenuSelectionContextProvider} from "./contexts/MenuSelectionContext"
import {Routes, Route} from "react-router-dom"
import {PaymentContextProvider} from "./contexts/PaymentContext"
import {MerchantContextProvider} from "./contexts/MerchantContext"
import Receipt from "./pages/Receipt"
import Playground from "./pages/Playground"
import {PagaStatusContextProvider} from "./contexts/PagaStatusContext"
import {CardContextProvider} from "./contexts/CardContext";
import {useAmplitudeTracker} from "./components/elements/AmplitudeTracker";
import SessionPageWrapper from './pages/SessionPageWrapper'

function App() {

    const checkoutApp = () =>
        <PaymentContextProvider>
            <MerchantContextProvider>
                <Secure3DContextProvider>
                    <PagaStatusContextProvider>
                        <PaymentStatusContextProvider>
                            <MenuSelectionContextProvider>
                                <CardContextProvider>
                                    <Checkout/>
                                </CardContextProvider>
                            </MenuSelectionContextProvider>
                        </PaymentStatusContextProvider>
                    </PagaStatusContextProvider>
                </Secure3DContextProvider>
            </MerchantContextProvider>
        </PaymentContextProvider>
    useAmplitudeTracker();
      return (
          <Routes>

              <Route path="/" element={checkoutApp()}/>
              <Route path="/payment-complete" element={<Receipt/>}/>
              <Route path="/session/:sessionId" element={<SessionPageWrapper/>}/>
              <Route path="/playground" element={<Playground/>}/>
          </Routes>
      )
}

export default App
